import classNames from "classnames";
import React, { useState } from "react";
import { TrackingEvents, track } from "../../../../util/analytics.util";
import { ButtonGroup, SkipButton, SlideLayout } from "../../shared-components";
import { AnimatedSlides } from "./AnimatedSlides";

export const CarouselSlide = ({
  goBack,
  goForward,
}: {
  goForward: () => void;
  goBack: () => void;
}) => {
  const animatedSlides = AnimatedSlides;
  const lastSlide = animatedSlides.length - 1;
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const currentSlideAnimation = animatedSlides[currentSlide];

  const isLastSlide = currentSlide === lastSlide;
  const isFirstSlide = currentSlide === 0;
  const goBackSlide = () => {
    track(TrackingEvents.WEB_ONBOARDING.CAROUSEL_SLIDE_BACK);
    if (isFirstSlide) {
      goBack();
    } else {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const goForwardSlide = () => {
    track(TrackingEvents.WEB_ONBOARDING.CAROUSEL_SLIDE_NEXT);
    if (isLastSlide) {
      goForward();
    } else {
      setCurrentSlide(currentSlide + 1);
    }
  };

  const gotoSlide = (newSlide: number) => {
    track(TrackingEvents.WEB_ONBOARDING.CAROUSEL_SLIDE_GO_TO, { slide: newSlide });
    setCurrentSlide(newSlide);
  };

  const onSkip = () => {
    track(TrackingEvents.WEB_ONBOARDING.CAROUSEL_SLIDE_SKIPPED);
    goForward();
  };

  return (
    <SlideLayout>
      <div className="cw-flex cw-flex-col cw-flex-1 cw-items-center cw-justify-between md:cw-justify-around">
        {currentSlideAnimation}
        <div className="cw-flex cw-justify-center cw-items-center cw-mt-6 cw-gap-2">
          {animatedSlides.map((_a, i) => {
            const isSelected = i === currentSlide;
            return (
              <div
                key={`stepIndicator-${i}`}
                onClick={() => gotoSlide(i)}
                className={classNames(
                  "cw-h-2 cw-w-2 cw-rounded-full cw-transition cw-duration-100 cw-ease-in-out cw-border cw-border-solid",
                  {
                    "cw-border-neutral-emphasis cw-bg-transparent hover:cw-bg-neutral-hover active:cw-bg-neutral-pressed cw-cursor-pointer": !isSelected,
                    "cw-border-brand-emphasis cw-bg-brand-emphasis": isSelected,
                  },
                )}
              ></div>
            );
          })}
        </div>
      </div>
      <ButtonGroup
        shouldShowSecondary={true}
        primaryLabel={isLastSlide ? "Get Started" : "Next Slide"}
        secondaryLabel={"Back"}
        onClickPrimary={goForwardSlide}
        onClickSecondary={goBackSlide}
      />
      <SkipButton onSkip={onSkip}> Skip intro</SkipButton>
    </SlideLayout>
  );
};
